import { workedSeconds } from "./consolidationPresentation.js";
import { hoursLabel } from "./consolidationOverview.js";
import { isDompeurSheet } from "./consolidationDompeur.js";
import { paidBreakSeconds } from "./consolidationBreaks.js";

function exactAllocationSeconds(calculation, timing) {
  if (calculation && !calculation.partial) {
    const total = (calculation.charges || []).filter(charge => charge.billing_unit === "heure")
      .reduce((sum, charge) => sum + Number(charge.quantity) * 3600, 0);
    return Number.isFinite(total) ? total : null;
  }
  if (timing?.available_seconds == null || timing.timing_errors?.length) return null;
  const total = Number(timing.available_seconds);
  return Number.isFinite(total) && total >= 0 ? total : null;
}

// Total complet des heures, même si la répartition par coop reste provisoire.
export function allocationHoursSeconds(calculation, timing) {
  const total = exactAllocationSeconds(calculation, timing);
  return total == null ? null : Math.round(total);
}

// Préchargement réalisé pendant le service : ses heures sont facturées sur sa propre fiche.
export function preloadSeconds(sheet) {
  return (sheet.exclusions || []).filter(preload => preload.kind !== "sheet").reduce((sum, preload) => {
    const start = Date.parse(preload.start_at), end = Date.parse(preload.end_at);
    return sum + (end > start ? (end - start) / 1000 : 0);
  }, 0);
}

// Arrêts non livrés ou exclus : leur temps n'est facturé à personne.
export function unbilledSeconds(calculation, timing) {
  if (calculation && !calculation.partial) return Number(calculation.excluded_seconds) || 0;
  return (timing?.blocks || []).filter(block => block.execution_excluded).reduce((sum, block) => sum + (Number(block.net_seconds) || 0), 0);
}

// Comparer les heures sources, avant l'arrondi de chaque coop pour l'affichage ; un dompeur facture les tonnes livrées.
export function sheetHoursBalance(sheet, calculation, timing) {
  if (sheet.manual_order_id || isDompeurSheet(sheet)) return null;
  const worked = workedSeconds(sheet);
  if (worked == null) return null;
  const billed = exactAllocationSeconds(calculation, timing);
  if (billed == null) return null;
  // Pause payée : dans les heures du chauffeur, facturée à personne.
  const paid = paidBreakSeconds(sheet), preloads = preloadSeconds(sheet), unbilled = unbilledSeconds(calculation, timing);
  const gap = Math.round(Math.abs(worked - paid - preloads - unbilled - billed));
  return { worked, billed: Math.round(billed), paid: Math.round(paid), preloads: Math.round(preloads), unbilled: Math.round(unbilled), gap, matches: gap === 0 };
}

export function hoursBalanceReason(balance) {
  if (!balance || balance.matches) return null;
  const gap = balance.gap < 60 ? `${balance.gap} s` : hoursLabel(balance.gap);
  const explained = [[balance.paid, "pause payée non facturée"], [balance.preloads, "préchargement sur sa fiche"], [balance.unbilled, "arrêts non facturés"]]
    .filter(([seconds]) => seconds > 0).map(([seconds, label]) => `, ${label} ${hoursLabel(seconds)}`).join("");
  return `Les heures ne concordent pas : chauffeur ${hoursLabel(balance.worked)}, facturé aux entreprises ${hoursLabel(balance.billed)}${explained} (écart ${gap}). Corrigez le relevé avant de valider.`;
}
